import { handleResponse } from "../../helpers/handleresponse";
import { authHeader } from "../../helpers/authHeader";

export const confirmationService = {
  create,
  createRange,
  update,
  deleteConfirmation, 
  get, 
  getByEvent,
  
}

async function get(confirmationId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader({ "Content-Type": "application/json" })
  
    };
    return fetch(`./api/confirmation/${confirmationId}`, requestOptions)
      .then(handleResponse)
      .then(confirmation => {
        return confirmation;
      });
  }

  async function getByEvent(eventId, includeInherited) {
    const requestOptions = {
      method: "GET",
      headers: authHeader({ "Content-Type": "application/json" })
  
    };
    return fetch(`./api/confirmation/event/${eventId}?includeInherited=${includeInherited}`, requestOptions)
      .then(handleResponse)
      .then(confirmationList => {
        return confirmationList
      });
  }
  async function update(confirmation) {
    const requestOptions = {
      method: "PUT",
      headers: authHeader({ "Content-Type": "application/json" }),
      body: JSON.stringify(confirmation)
    };
  
    return fetch(`./api/confirmation`, requestOptions)
      .then(handleResponse)
      .then(confirmation => {
        return confirmation;
      });
  }
  async function create(confirmation) {
      const requestOptions = {
        method: "POST",
        headers: authHeader({ "Content-Type": "application/json" }),
        body: JSON.stringify(confirmation)
      };
    
      return fetch(`./api/confirmation`, requestOptions)
        .then(handleResponse)
        .then(confirmation => {
          return confirmation;
        });
    }
    async function createRange(eventId, confirmations) {
      const requestOptions = {
        method: "POST",
        headers: authHeader({ "Content-Type": "application/json" }),
        body: JSON.stringify(confirmations)
      };
    
      return fetch(`./api/confirmation/range/${eventId}`, requestOptions)
        .then(handleResponse)
        .then(confirmations => {
          return confirmations;
        });
    }
    async function deleteConfirmation(confirmationId) {
      const requestOptions = {
        method: "DELETE",
        headers: authHeader({ "Content-Type": "application/json" }),
      };
    
      return fetch(`./api/communication/${confirmationId}`, requestOptions)
        .then(handleResponse)
        .then(_ => {
          return _;
        });
    }